/**
 * Constants related to index sets.
 */
export default class IndexSetConstants {
}
IndexSetConstants.MASK_BOTTOMBITS = 31;
IndexSetConstants.MASK_TOPBITS = (~IndexSetConstants.MASK_BOTTOMBITS) >>> 0;
IndexSetConstants.SHIFT_TOPBITS = 5;
